import findTopWindow from './findTopWindow';
import getQueryParameter from './getQueryParameter';

const internal =
  getQueryParameter('internal') ||
  getQueryParameter('internal', findTopWindow());
const local =
  getQueryParameter('local') || getQueryParameter('local', findTopWindow());
const content = internal ? 'content/internal' : 'content/live';
const o = window.location.origin;
let sld = window.location.hostname.split('.')[1];
sld = sld?.includes('vinciworks') ? sld : 'vinciworks';

const origin = local
  ? ''
  : o.includes('//local') || o.includes('//omnidev')
    ? `https://portal.${sld}.com`
    : o.includes('//authors')
      ? o.replace('authors', 'portal')
      : // default to empty so links are absolute
        '';

const contentBase = `${origin}/awscontent/${content}`;

export default function getContentBase() {
  return contentBase;
}
